var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3219 5.2625C20.0063 5.94594 20.0063 7.05406 19.3219 7.7375L18.3844 8.67812L15.3219 5.61625L16.2625 4.67687C16.9469 3.99333 18.0531 3.99333 18.7375 4.67687L19.3219 5.2625ZM9.3875 11.5531L14.6156 6.32312L17.6781 9.38437L12.4469 14.6125C12.2562 14.8062 12.0219 14.95 11.7625 15.0375L8.9875 15.9625C8.69063 16.05 8.42188 15.9812 8.21875 15.7531C8.01875 15.5781 7.95 15.2812 8.0375 15.0125L8.9625 12.2375C9.05 11.9781 9.19375 11.7437 9.3875 11.5531ZM10 5.97187C10.5531 5.97187 11 6.44781 11 6.97187C11 7.55312 10.5531 7.97187 10 7.97187H7C6.44781 7.97187 6 8.44687 6 8.97187V17C6 17.5531 6.44781 18 7 18H15C15.5531 18 16 17.5531 16 17V13.9719C16 13.4469 16.4469 12.9719 17 12.9719C17.5531 12.9719 18 13.4469 18 13.9719V17C18 18.6562 16.6562 20 15 20H7C5.34312 20 4 18.6562 4 17V8.97187C4 7.31562 5.34312 5.97187 7 5.97187H10Z",
    fill: "#270ADC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/EditButton.1cfc4de669a5ebd91d758a2b2031322e.svg";
export { ForwardRef as ReactComponent };